import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { theme } from '../../../theme/theme';

const { general, sixth } = theme;

// Define element styles for the component
const StyledLabel = styled(Form.Label).withConfig({
  shouldForwardProp: (prop) => prop !== 'isNewDesign',
})`
  color: ${({ color, isNewDesign }) => {
      if (isNewDesign) return sixth;
      return (color || general);
    }
  };
  margin-bottom: 0;
  font-size: ${({ isNewDesign }) => isNewDesign ? '15px !important' : '16px !important'};
  margin-bottom: ${({ isNewDesign }) => isNewDesign ? '2px' : '0'};
`;

/**
 * Label component
 * @component
 * @param {Element} children
 * @returns
 */
export const Label = ({ children, ...props }) => {
  return <StyledLabel { ...props }>{ children }</StyledLabel>;
};

Label.propTypes = {
  children: PropTypes.any,
  isNewDesign: PropTypes.bool
};
